import { render, staticRenderFns } from "./BaseOverview.vue?vue&type=template&id=61bae7a8&scoped=true"
import script from "./BaseOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bae7a8",
  null
  
)

export default component.exports